import AppModel from "models/AppModel";
import Stereotype from "models/Stereotype";
import { BackboneRecordBrowserModule } from "lib/recordBrowser/RecordBrowserModule";
import RecordBrowserState from "models/RecordBrowserState";
import { asMarionetteView } from "lib/common/hoc/BackboneReact/asMarionetteView";
import Dispatcher from "Dispatcher";
import ContextActions from "data/util/ContextActions";
import StereotypesStore from "data/StereotypesStore";
import SearchFormActions from "data/SearchFormActions";
import RecordBrowserActions from "data/RecordBrowserActions";

const MarionetteRecordBrowserModule = asMarionetteView(
    BackboneRecordBrowserModule,
    {
        className: "record-browser",
    },
);

class RecordBrowserController extends Backbone.Controller {
    constructor(...args) {
        super(...args);
        this.initialize = this.initialize.bind(this);
        this.onGlobalLookup = this.onGlobalLookup.bind(this);
    }

    initialize(options) {
        this.model = options.model;
        this.app = options.app;
        this.fluxToken = Dispatcher.register(action => {
            // eventually this should live in a proper flux store.
            switch (action.type) {
                case RecordBrowserActions.GLOBAL_LOOKUP_CLICK:
                    this.onGlobalLookup(
                        action.key,
                        action.lookupCallback,
                        action.focusCallback,
                        action.candidateFilter,
                        action.currId,
                    );
                break;
                default:
            }
        });
    }

    onClose() {
        Dispatcher.unregister(this.fluxToken);
    }

    onGlobalLookup(
        key,
        lookupCallback,
        focusCallback,
        candidateFilter,
        currId,
    ) {
        // todo: get currId wherever it needs to be so the corresponding record can always be "hot" in the modal
        const deModel = new AppModel();
        deModel.set("isModal", true);
        const recordBrowserState = new RecordBrowserState({
            candidateFilter,
            currId,
            isGlobal: true,
            deModel,
        });

        StereotypesStore.getStereotypeLO(key)
            .promise()
            .then(data => {
                Dispatcher.contextDispatch(deModel.get("fluxContext"), {
                    type: SearchFormActions.INITIALIZE_CONTEXT,
                    key: key,
                    availableKeys: [key],
                });
                const lookup = new Stereotype(data);

                recordBrowserState.set({
                    stereotype: lookup,
                });

                if (lookupCallback != null) {
                    recordBrowserState.set("closeOnSelect", true);
                    this.listenToOnce(
                        recordBrowserState,
                        "change:selected",
                        lookupCallback,
                    );
                }

                this.app.layout.showModal(() =>
                    new MarionetteRecordBrowserModule({
                        app: this.app,
                        title: data.name,
                        deModel,
                    }))
                    .then(() => {
                        // This timeout allows the rest of the view hierarchy to
                        // close before we act on the new state
                        //
                        // eslint-disable-next-line no-settimeout
                        setTimeout(() => {
                            Dispatcher.contextDispatch(deModel.get("fluxContext"), {
                                type: ContextActions.CLOSE,
                            });
                            if (focusCallback != null) {
                                focusCallback();
                            }
                        }, 0);
                    });
            });
    }
}

RecordBrowserController.prototype.events = {
    "load:global_lookup": "onGlobalLookup",
};

export default RecordBrowserController;



// WEBPACK FOOTER //
// ./app/controllers/RecordBrowserController.js